/**
 * Mission-clock countdown for title cards (S2-10): `T−02:29`, `T+00:45`, `T−2 d 05 h`. Pure, unit-tested.
 */
const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

/** Formats `deltaMs` = now − event time; within ±`nowWindowMs` the event is "now" (returns null). */
export function formatCountdown(deltaMs: number, nowWindowMs = 10 * MIN): string | null {
  if (Math.abs(deltaMs) < nowWindowMs) return null;
  const sign = deltaMs < 0 ? 'T−' : 'T+';
  const abs = Math.abs(deltaMs);
  const pad = (n: number): string => String(n).padStart(2, '0');
  if (abs >= DAY) return `${sign}${Math.floor(abs / DAY)} d ${pad(Math.floor((abs % DAY) / HOUR))} h`;
  return `${sign}${pad(Math.floor(abs / HOUR))}:${pad(Math.floor((abs % HOUR) / MIN))}`;
}

/**
 * Whether mission time passed `eventMs` between two looks at the clock (`beforeMs` → `nowMs`, either direction). At
 * fast playback the clock jumps further than the "now" window between two title-card samples (6 h/s: 36 minutes per
 * 100 ms) — the crossing still counts as the moment (S4-15 item 2).
 */
export function crossed(beforeMs: number, nowMs: number, eventMs: number): boolean {
  if (!Number.isFinite(beforeMs)) return false;
  return (beforeMs < eventMs && nowMs >= eventMs) || (beforeMs > eventMs && nowMs <= eventMs);
}
